module.exports = __webpack_public_path__ + "img/1_2-commerciale-museo-0.5cffa0a4.png";